import './style.css';
import React, { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'
import CharacterSidebar from './components/character-sidebar.jsx';
import CharacterSearch from './components/character-search.jsx'
import Navbar, { VIEWS } from './components/navbar.jsx';
import CharacterView1 from './components/character-view1.jsx';
import CharacterView2 from './components/character-view2.jsx';
import CharacterData from './characterdata.json';
import View2CharacterData from './view2characterdata.json'
import CharacterMobileNavbar from './components/character-mobile-navbar';
import ScrollIndicator from './components/scroll-indicator.jsx';
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import SettingsDrawer from './components/mobile/settings-drawer.jsx'
import { nanoid } from 'nanoid';
import MobileAddNote from './components/mobile/mobile-addnote.jsx';
import MobileNotelist from './components/mobile/mobile-notelist'
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import { useMediaQuery } from '@mui/material';
import useDarkSide from './components/usedarkSide';
import Tooltip from '@mui/material/Tooltip';



const drawerWidth = 304;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        // padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        ...(open ? {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: `${drawerWidth}px`,
        } : {}),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    '@media (min-width: 1600px)': {
        right: 'auto',
        left: 'auto',
      },
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),

    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        '@media (min-width: 1600px)': {
            width: `calc(1600px - ${drawerWidth}px)`,
            right: 'auto',
          },
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));


const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));


const fontSizes = {
    small: { value: 16, title: 'Small' },
    medium: { value: 18, title: 'Medium' },
    large: { value: 20, title: 'Larget' },
}

// Object.values(fontSizes).map(option =>
//   <button key={option.value} onClick={() => handleFontChange(option.value)}>{option.title}</button>)

// const monekys = [{ id: 1, name: 'one', descripton: 'asfd' }, { id: 2, name: 'two', description: '' }];

// const [activeMoneky, setActiveMonkey] = useState(monkeys[0]);
// monekys.map(monkey => <div onClick={() => {
//   setActiveMonkey(monkey);
// }}>{monkey.name}</div>);

// { activeMoneky ? <MonkeyPage monkey={activeMonkey} /> : <div>empty</div> }

const Character = ({user}) => {

    const theme = useTheme();
    const [open, setOpen] = React.useState(true);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };


    const [fontSize, setFontSize] = useState(
        localStorage.getItem('fontSize') || '24px'
      );
    
      useEffect(() => {
        localStorage.setItem('fontSize', fontSize);
      }, [fontSize]);
    
      const handleSizeClick = (size) => {
        setFontSize(size);
      };



      const [fontStyle, setFontStyle] = useState(
        localStorage.getItem('fontStyle') || 'DM Mono'
      );
    
      useEffect(() => {
        localStorage.setItem('fontStyle', fontStyle);
      }, [fontStyle]);
    
      const handleStyleClick = (style) => {
        setFontStyle(style);
      };


      const [mobFontSize, setMobFontSize] = useState(
        localStorage.getItem('mobile-fontSize') || '20px'
      );
    
      useEffect(() => {
        localStorage.setItem('mobile-fontSize', mobFontSize);
      }, [mobFontSize]);
    
      const handleMobSizeClick = (size) => {
        setMobFontSize(size);
      };



    const [searchText, setSearchText] = useState('');
    // const [showResults, setShowResults] = useState(false);
    // const [fontSize, setFontSize] = useState(24);
    const [lineHeight, setLineHeight] = useState(50);
    // const [mobFontSize, setMobFontSize] = useState(18);
    // const [fontStyle, setFontStyle] = useState("DM Mono");
    const [active, setActive] = useState(VIEWS.vertical);
    const [bookmark, setBookmark] = useState([]);
    const [jumpToPage, setJumpToPage] = useState(1);
    const [scrollTop, setSCrollTop] = useState(0);
    const [isChapterOpen, setIsChapterOpen] = React.useState(false)
    const [isSettingsOpen, setIsSettingsOpen] = React.useState(false)
    const [isNotelistOpen, setIsNotelistOpen] = React.useState(false)
    const [isSearchOpen, setIsSearchOpen] = React.useState(false)


    const matches = useMediaQuery(theme.breakpoints.up('lg'));
    const isDesktop = !!matches;

    // const updateFontSize = (nextValue) => {
    //   setFontSize(nextValue);
    // }

    const handleFSizeS = () => {
        setFontSize(20)
        setLineHeight(30)
    }

    const handleFSizeM = () => {
        setFontSize(24)
        setLineHeight(50)
    }

    const handleFSizeL = () => {
        setFontSize(28)
        setLineHeight(70)
    }

    const handleMFSizeS = () => {
        setMobFontSize(16)
    }

    const handleMFSizeM = () => {
        setMobFontSize(18)
    }

    const handleMFSizeL = () => {
        setMobFontSize(20)
    }

    const handleFStyle = (newFont) => {
        setFontStyle(newFont)
    }


    // nextTab either be vertical or horizontal
    const handleView = (nextTab) => {
        setActive(nextTab);
    }

    const handleBookmark = (pg, chapter_no) => {
        const newBookmark = {
            page_number: pg,
            chapter_number: chapter_no
        }
        const exists = bookmark.find((b) => b.page_number === pg)
        if (exists) return handleDeleteBookmark(pg);
        const newBookmarks = [...bookmark, newBookmark]
        setBookmark(newBookmarks)
    }

    const handleDeleteBookmark = (pg) => {
        const newBookmarks = bookmark.filter((b) => b.page_number !== pg)
        setBookmark(newBookmarks)
        console.log(setBookmark)
    }

    const handleChapterClick = (value) => {
        setJumpToPage(value);
    }


    const onScroll = () => {
        const winScroll = document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        setSCrollTop(scrolled);
    }

    useEffect(() => {
        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, [])

    const toggleChapterDrawer = () => {
        setIsChapterOpen((prevState) => !prevState)
    }

    const toggleSettingsDrawer = () => {
        setIsSettingsOpen((prevState) => !prevState)
    }

    const toggleNotelistDrawer = () => {
        setIsNotelistOpen((prevState) => !prevState)
    }

    const toggleSearchDrawer = () => {
        setIsSearchOpen((prevState) => !prevState)
    }


    const [notes, setNotes] = useState([
        {
            id: nanoid(),
            pagenumber: 'CHI/P1',
            text: 'Lorem ipsum dolor sit amet consectetur. Viverra cursus semper pulvinar at est.',
        },
        {
            id: nanoid(),
            pagenumber: 'CHI/P2',
            text: 'Lorem ipsum consectetur. Viverra cursus semper pulvinar at est.',
        },
        {
            id: nanoid(),
            pagenumber: 'CHI/P3',
            text: 'Lorem ipsum dolor sit amet consectetur. semper pulvinar at est.',
        },
        {
            id: nanoid(),
            pagenumber: 'CHI/P4',
            text: 'Lorem ipsum dolor sit amet consectetur. Viverra cursus semper pulvinar at est.',
        },
        {
            id: nanoid(),
            pagenumber: 'CHI/P5',
            text: 'Lorem ipsum dolor sit amet consectetur. Viverra cursus semper pulvinar at est.',
        },
    ])

    const addNote = (text) => {
        const newNote = {
            id: nanoid(),
            pagenumber: 'CHI/P6',
            text: text
        }
        const newNotes = [...notes, newNote];
        setNotes(newNotes);
    }

    const deleteNote = (id) => {
        const newNotes = notes.filter((note) => note.id !== id);
        setNotes(newNotes);
    }

    const [colorTheme, setTheme] = useDarkSide();
    const [darkSide, setDarkSide] = useState(
        colorTheme === "light" ? true : false
    );

    const toggleDarkMode = (checked) => {
        setTheme(colorTheme);
        setDarkSide(checked);
    };

    return (
        <>
            {isDesktop && (
                <Box className="bg-[#FAF8F1] flex dark:bg-black" style={{ backgroundImage: "url('main-bg-img.svg')" }}>
                    <body className='max-w-[1600px] mx-auto '>
                    <div className='flex'>

                        <AppBar position="fixed" z-index='-1' open={open} style={{boxShadow: 'none'}} className='max-w-[1600px]' >
                            <div className='flex items-center justify-between pt-5 pb-4 px-4 sticky top-0 bg-[#FAF8F1] dark:bg-black' style={{ backgroundImage: "url('appbar-bg-img.svg')" }}>
                                <div className='flex items-center'>
                                    <button
                                        aria-label="open drawer"
                                        onClick={() => setOpen(prev => !prev)}
                                        edge="start"
                                        sx={{ ...(open && { display: 'none' }) }}
                                        className='border-[1px] border-[#CBCAC7] p-[13px] mr-4 dark:border-[#303030] hover:drop-shadow-[0_10px_24px_rgba(0,0,0,0.03)] hover:border-[1px] hover:border-[#515151] hover:dark:border-[#b1b1b1] ease-linear transition-all duration-150'>
                                        <img src={open ? darkSide ? "dark_closedrawer.svg" : "closedrawer.svg" : darkSide ? "dark_opendrawer.svg" : 'opendrawer.svg'} />
                                    </button>

                                    <CharacterSearch placeholder="Search here.." CharacterData={CharacterData} darkSide={darkSide} />
                                </div>

                                <Navbar active={active} handleView={handleView} darkSide={darkSide} />
                            </div>
                        </AppBar>

                        <Drawer
                            sx={{
                                width: drawerWidth,
                                flexShrink: 0,
                                '& .MuiDrawer-paper': {
                                    width: drawerWidth,
                                    boxSizing: 'border-box',
                                },
                            }}
                            variant={"persistent"}
                            anchor="left"
                            open={open}
                            overlayOpacity='0'
                            zIndex='-10'
                        >
                            <div className='bg-[#FAF8F1] pl-4 h-[100vh] dark:bg-black' style={{ backgroundImage: "url('sidebar-bg-img.svg')" }}>
                                <Tooltip title="Go to Home Page" placement="right">
                                    <Link to='/stories'>
                                        <button className='mt-[14px] hover:-translate-y-0.5 ease-linear transition-all duration-150'>
                                            <img className='sticky top-4 h-[50px] w-[50px]' src="chimp-logo.png" />
                                        </button>
                                    </Link>
                                </Tooltip>
                                <CharacterSidebar user={user} activeView={active} handleSizeClick={handleSizeClick} handleStyleClick={handleStyleClick} handleFStyle={handleFStyle} fontStyle={fontStyle} handleFSizeS={handleFSizeS} handleFSizeM={handleFSizeM} handleFSizeL={handleFSizeL} fontSize={fontSize} bookmark={bookmark} handleChapterClick={handleChapterClick} jumpToPage={jumpToPage} toggleDarkMode={toggleDarkMode} darkSide={darkSide} />
                            </div>
                        </Drawer>

                        <Main className='px-4 pt-20 z-[1] bg-[#FAF8F1] dark:bg-black' open={open} style={{ backgroundImage: "url('main-bg-img.svg')" }}>
                            <div>
                                {active === VIEWS.vertical && <CharacterView1
                                    fontSize={fontSize}
                                    fontStyle={fontStyle}
                                    lineHeight={lineHeight}
                                    CharacterData={CharacterData}
                                    // Data={handleSearchNote}
                                    handleBookmark={handleBookmark}
                                    jumpToPage={jumpToPage}
                                    darkSide={darkSide}
                                />}
                            </div>

                            <div>
                                {active === VIEWS.horizontal && <CharacterView2
                                    fontSize={fontSize}
                                    fontStyle={fontStyle}
                                    lineHeight={lineHeight}
                                    View2CharacterData={View2CharacterData}
                                    handleBookmark={handleBookmark}
                                    jumpToPage={jumpToPage}
                                    open={open}
                                />}
                            </div>
                        </Main>
                        </div>
                    </body>
                </Box>
            )}



            <div className='bg-[#FAF8F1]'>
                {/* <div className="hidden w-[97%] mx-auto lg:block">
          <div className='flex'>

            <div>
              <img className='sticky top-4' src="chimp-logo.svg" />
              <Sidebar handleFStyle={handleFStyle} handleFSizeS={handleFSizeS} handleFSizeM={handleFSizeM} handleFSizeL={handleFSizeL} bookmark={bookmark} handleChapterClick={handleChapterClick} jumpToPage={jumpToPage} />
            </div>

            <div className='ml-4 w-full'>

              <div className='flex items-center justify-between pt-5 pb-4 sticky top-0 z-[10] bg-[#FAF8F1]'>
                <div className='flex items-center'>
                  <div className='border-[1px] border-[#CBCAC7] p-[13px] mr-4'>
                    <img src='vector.svg' />
                  </div>

                  <Search handleSearchNote={setSearchText} />
                </div>

                <Navbar active={active} handleView={handleView} />
              </div>


              <div>
                {active === VIEWS.vertical && <View1
                  fontSize={fontSize}
                  fontStyle={fontStyle}
                  Data={Data.filter((data) => data.content.toLowerCase().includes(searchText))}
                  // Data={handleSearchNote}
                  handleBookmark={handleBookmark}
                  jumpToPage={jumpToPage}
                />}
              </div>

              <div>
                {active === VIEWS.horizontal && <View2
                  fontSize={fontSize}
                  fontStyle={fontStyle}
                  View2Data={View2Data.filter((v2data) => v2data.left_content.toLowerCase().includes(searchText))}
                  handleBookmark={handleBookmark}
                  jumpToPage={jumpToPage}
                />}
              </div>

            </div>

          </div>
        </div> */}


                {/* Mobile View */}
                {!isDesktop && (
                    <div className='block'>

                        <CharacterMobileNavbar toggleChapterDrawer={toggleChapterDrawer} toggleSearchDrawer={toggleSearchDrawer} toggleNotelistDrawer={toggleNotelistDrawer} toggleSettingsDrawer={toggleSettingsDrawer} darkSide={darkSide} />

                        <Drawer open={isChapterOpen} onClose={toggleChapterDrawer} direction='top' size='600' className='z-[1101] border-b-[2px] border-[#242424] !bg-[#FAF8F1]'>
                            <div className='w-full h-[1px] bg-[#E0DED8] mt-16'></div>
                            <div className='p-5 bg-[#FAF8F1] dark:bg-[#242424]'>
                                <CharacterSidebar handleFStyle={handleFStyle} handleFSizeS={handleFSizeS} handleFSizeM={handleFSizeM} handleFSizeL={handleFSizeL} bookmark={bookmark} handleChapterClick={handleChapterClick} jumpToPage={jumpToPage} darkSide={darkSide} />
                            </div>
                        </Drawer>

                        <Drawer open={isSearchOpen} onClose={toggleSearchDrawer} direction='top' size='600' className='z-[1101] border-b-[2px] border-[#242424] !bg-[#FAF8F1]'>
                            <div className='w-full h-[1px] bg-[#E0DED8] mt-16'></div>
                            <div className='py-8 bg-[#FAF8F1] dark:bg-[#242424]'>
                                <CharacterSearch darkSide={darkSide} placeholder="Search here.." CharacterData={CharacterData} />
                            </div>
                        </Drawer>

                        <Drawer open={isNotelistOpen} onClose={toggleNotelistDrawer} direction='top' size='600' variant="persistent" className='z-[1101] border-b-[2px] border-[#242424] !bg-[#FAF8F1]'>
                            <div className='w-full h-[1px] bg-[#E0DED8] mt-16'></div>
                            <div className='p-5 bg-[#FAF8F1] dark:bg-[#242424]' style={{ height: `calc(100vh - 65px)`, overflow: 'auto' }}>
                                <MobileNotelist notes={notes} handleAddNote={addNote} handleDeleteNote={deleteNote} />
                            </div>
                        </Drawer>

                        <Drawer open={isSettingsOpen} onClose={toggleSettingsDrawer} direction='top' size='600' className='z-[1101] border-b-[2px] border-[#242424] !bg-[#FAF8F1]'>
                            <div className='w-full h-[1px] bg-[#E0DED8] mt-16'></div>
                            <div className='p-5 bg-[#FAF8F1] dark:bg-[#242424]'>
                                <SettingsDrawer user={user} handleMobSizeClick={handleMobSizeClick} handleStyleClick={handleStyleClick} handleMFSizeS={handleMFSizeS} handleMFSizeM={handleMFSizeM} handleMFSizeL={handleMFSizeL} mobFontSize={mobFontSize} handleFStyle={handleFStyle} fontStyle={fontStyle} toggleDarkMode={toggleDarkMode} darkSide={darkSide} />
                            </div>
                        </Drawer>

                        <div>
                            {active === VIEWS.vertical && <CharacterView1
                                fontSize={fontSize}
                                mobFontSize={mobFontSize}
                                lineHeight={lineHeight}
                                fontStyle={fontStyle}
                                CharacterData={CharacterData}
                                // Data={handleSearchNote}
                                handleBookmark={handleBookmark}
                                jumpToPage={jumpToPage}
                                darkSide={darkSide}
                            />}
                        </div>

                        {/* <div className='fixed bottom-3 right-3'>
                            <MobileAddNote handleAddNote={addNote} darkSide={darkSide} />
                        </div> */}

                    </div>

                )}


            </div>
        </>
    );
};

export default Character;
